import { createPopper } from '@popperjs/core';

const showAttribute = 'data-show';

export const bindTooltip = (anchor, tooltip) => {
	if (!anchor || !tooltip) {
		if (!anchor) console.warn('No anchor provided');
		if (!tooltip) console.warn('No tooltip provided');
		return;
	}

	// Create a Popper instance
	const popperInstance = createPopper(anchor, tooltip, {
		placement: tooltip.getAttribute('data-tooltip-placement') || 'top',
	});

	const show = () => {
		// Make the tooltip visible
		tooltip.setAttribute(showAttribute, '');

		// Enable the event listeners
		popperInstance.setOptions((options) => ({
			...options,
			modifiers: [...options.modifiers, { name: 'eventListeners', enabled: true }],
		}));

		// Update its position
		popperInstance.update();
	};

	const hide = () => {
		// Hide the tooltip
		tooltip.removeAttribute(showAttribute);

		// Disable the event listeners
		popperInstance.setOptions((options) => ({
			...options,
			modifiers: [...options.modifiers, { name: 'eventListeners', enabled: false }],
		}));
	};

	['mouseenter', 'focus'].forEach((type) => {
		anchor.addEventListener(type, show);
	});

	['mouseleave', 'blur'].forEach((type) => {
		anchor.addEventListener(type, hide);
	});

	return { show, hide };
};
